import { render, staticRenderFns } from "./list1.vue?vue&type=template&id=07c11f52&scoped=true&"
import script from "./list1.vue?vue&type=script&lang=js&"
export * from "./list1.vue?vue&type=script&lang=js&"
import style0 from "./list1.vue?vue&type=style&index=0&id=07c11f52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c11f52",
  null
  
)

export default component.exports